// Тут необходимо зарегистрировать константу для env переменной REACT_APP_DEFAULT_ICON
export const logo_default = require('./logo_default.svg');
export const nexgen = require('./nexgen.svg');
export const worktrade = require('./WorkTrade.png');
export const financeadvice = require('./financeadvice.svg');
export const alaris = require('./alaris.svg');
export const maritime = require('./maritime.svg');
export const dws = require('./dws.svg');
export const arow = require('./arow.svg');
export const colville = require('./colville.svg');
export const brsg = require('./brsg.svg');
export const hfi = require('./hfi.svg');
export const bs = require('./bs.svg');
export const profinus = require('./profinus.svg');
export const aspect = require('./aspect.svg');
export const vfr = require('./vfr.svg');
